const basePath = '/api/1.0/web/1.0/';
import common from '@/common/common'
let langTranslation = common.langTranslation;
import axios from "axios";

/**
 * 默认处理
 * @param axios
 * @returns {Promise}
 */
function defaultDo(axios) {
    let st = 0;
    let timer = setTimeout(function () {
        //显示加载中
        st = +new Date;
    }, 500);

    function closeTip() {
        clearTimeout(timer);
        if (st) {
            setTimeout(function () {

            }, Math.max(300 + st - new Date, 0));
        }

    }

    return new Promise((resolve, reject) => {
        axios.then(function (json) {
            closeTip();
            if (json && json.state) {
                resolve(json);
            } else {
                reject(json);
            }

        }).catch(function () {
            closeTip()
            reject({state: false, message: langTranslation('接口响应错误')})
        })
    })

}


export function getInfo(){
    return defaultDo(axios({
        url:'/api/1.0/web/1.0/fil_spider/index',
        method:'get',
    }));
}
export function calc(form){
    return defaultDo(axios({
        url:'/api/1.0/web/1.0/fil_spider/calculator_data',
        method:'post',
        data:{
            form
        }
    }));
}


export function updateUserName(form){
    return defaultDo(axios({
        url:'/api/1.0/web/1.0/user/update_user_name',
        method:'post',
        data:{
            form
        },
    }));
}
